import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Node } from '@splashthat/splash-cms-engine';
import { BaseRenderer } from '../BaseRenderer';
import { actions } from './actions';

export function WebRenderer({ portal, initialTree, blocks, children }) {
    return (
        <BaseRenderer portal={portal}>
            {({ nodes }) => {
                const dataSet = Object.keys(nodes).length ? nodes : initialTree;
                const root = Object.values(dataSet).find((node) => node.root);

                if (portal.current) {
                    return (
                        <>
                            {children}
                            {ReactDOM.createPortal(WebRenderer.renderTree(root, dataSet, blocks), portal.current)}
                        </>
                    );
                } else if (dataSet) {
                    return (
                        <>
                            {children}
                            {WebRenderer.renderTree(root, dataSet, blocks)}
                        </>
                    );
                }

                return null;
            }}
        </BaseRenderer>
    );
}

// eslint-disable-next-line default-param-last
WebRenderer.renderTree = ({ id, type, props, childNodes, ...otherProps } = {}, tree, blocks) =>
    Object.keys(tree).length ? (
        <Node {...props} {...otherProps} id={id} is={blocks[type]} type={type} childNodes={childNodes} key={id}>
            {childNodes?.map((childNodeKey) =>
                WebRenderer.renderTree({ ...tree[childNodeKey], parentId: id }, tree, blocks),
            )}
        </Node>
    ) : null;

WebRenderer.actions = actions;

WebRenderer.propTypes = {
    portal: PropTypes.shape({
        current: PropTypes.instanceOf(Element),
    }).isRequired,
    initialTree: PropTypes.shape({}).isRequired,
    blocks: PropTypes.arrayOf(PropTypes.func).isRequired,
    children: PropTypes.node,
};

WebRenderer.defaultProps = {
    children: null,
};
